import { ApplicationData } from '../../../../types/TymbeApi';
import ResolvedAttendanceRow from './ResolvedAttendanceRow';
import { BadgePill } from '@tymbe/ty-components/indicators';

type ResolvedAttendanceProps = {
  applications: ApplicationData[];
};

const ShiftResolvedAttendance = ({ applications }: ResolvedAttendanceProps) => {
  return (
    <div className="flex flex-col w-full mb-4">
      <div className="bg-white rounded-xl py-4">
        <div className="flex items-center gap-2">
          <span className="text-green-700 text-body-2-xl font-semibold">Potvrzená docházka</span>
          <BadgePill variant="success">{applications.length}</BadgePill>
        </div>
      </div>
      {applications.length ? (
        <div className="flex flex-col rounded-2xl md:border border-secondary-transparent-10 bg-green-100 md:divide-y md:divide-secondary-transparent-10">
          {applications.map((application) => (
            <ResolvedAttendanceRow key={application.id} application={application} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ShiftResolvedAttendance;
